import { AIType } from '@/pages/ISWAN_CHAT/interface';
import icon_analyze from './icon/icon_analyze.png';
import icon_analyze_active from './icon/icon_analyze_active.png';
import icon_app from './icon/icon_app.png';
import icon_app_active from './icon/icon_app_active.png';
import icon_chat from './icon/icon_chat.png';
import icon_chat_active from './icon/icon_chat_active.png';
import icon_decision from './icon/icon_decision.png';
import icon_decision_active from './icon/icon_decision_active.png';
import icon_know from './icon/icon_knowledge.png';
import icon_know_active from './icon/icon_knowledge_active.png';
import icon_robot from './icon/icon_robot.png';
import icon_robot_active from './icon/icon_robot_active.png';

export interface AiSelectDataItem {
  label: string;
  value: AIType;
  url: string;
  icon: string;
  icon_active: string;
  onlyCompany?: boolean;
}

export const aiSelectData: AiSelectDataItem[] = [
  {
    label: 'IYB Chat',
    value: 'Chat',
    url: '/iyb/chat',
    icon: icon_chat,
    icon_active: icon_chat_active,
  },
  {
    label: 'IYB 知识库',
    value: 'Knowledge',
    url: '/iyb/know',
    icon: icon_know,
    icon_active: icon_know_active,
  },
  // {
  //   label: 'IYB 工作助手',
  //   value: 'App',
  //   url: '/iyb/app',
  //   icon: icon_app,
  //   icon_active: icon_app_active,
  //   onlyCompany: true,
  // },
  // {
  //   label: 'IYB 数据分析',
  //   value: 'Analyze',
  //   url: '/iyb/analyze',
  //   icon: icon_analyze,
  //   icon_active: icon_analyze_active,
  //   onlyCompany: true,
  // },
  // {
  //   label: 'IYB 智脑决策',
  //   value: 'Decision',
  //   url: '/iyb/decision',
  //   icon: icon_decision,
  //   icon_active: icon_decision_active,
  //   onlyCompany: true,
  // },
  // {
  //   label: 'IYB 智能机器人',
  //   value: 'Robot',
  //   url: '/iyb/robot',
  //   icon: icon_robot,
  //   icon_active: icon_robot_active,
  //   onlyCompany: true,
  // },
];
